import {AuthProvider, FacebookAuthProvider, GoogleAuthProvider, OAuthProvider} from "firebase/auth";

export enum AuthProviderType {
  Google = "google.com",
  Facebook = "facebook.com",
  Apple = "apple.com",
  Clever = "gc.apple.com",
  ClassLink = "playgames.google.com",
  Microsoft = "microsoft.com",
  Password = "password",
}

const names: { [key in AuthProviderType]: string } = {
  [AuthProviderType.Google]: "Google",
  [AuthProviderType.Facebook]: "Facebook",
  [AuthProviderType.Microsoft]: "Microsoft",
  [AuthProviderType.Clever]: "Clever",
  [AuthProviderType.ClassLink]: "ClassLink",
  [AuthProviderType.Apple]: "Apple",
  [AuthProviderType.Password]: "Email and Password",
}

export const toAuthProviderName = (provider: AuthProviderType): string => {
  return names[provider];
}

const ssoProviders = [
  AuthProviderType.Google,
  AuthProviderType.Facebook,
  AuthProviderType.Apple,
  AuthProviderType.Microsoft,
  AuthProviderType.Clever,
  AuthProviderType.ClassLink,
];

export const isSsoProvider = (provider: AuthProviderType): boolean => {
  return ssoProviders.includes(provider);
}

const providers: { [key: string]: AuthProvider } = {
  "apple.com": new OAuthProvider("apple.com").setCustomParameters({prompt: "select_account"}),
  "google.com": new GoogleAuthProvider().setCustomParameters({prompt: "select_account"}),
  "facebook.com": new FacebookAuthProvider().setCustomParameters({prompt: "select_account"}),
  "microsoft.com": new OAuthProvider("microsoft.com").setCustomParameters({prompt: "select_account"}),
}

export const getProvider = (provider: AuthProviderType): AuthProvider => {
  const p = providers[provider];
  if (!p) {
    throw new Error(`No provider found for ${provider}`);
  }
  return p;
}